export default function ({ store, route }) {
  if (route.name === 'checkout') {
    if (store.state.orderId) {
      store.dispatch('updateOrder');
    } else {
      store.dispatch('createOrder');
    }
  }
}
